import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "double-chevron-back",
  "use": "double-chevron-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 24 24\" id=\"double-chevron-back\">\n  <g fill-rule=\"evenodd\">\n    <path d=\"m14.372 20.5-8.543-8.543 8.543-8.544L12.958 2 3 11.957l9.958 9.957z\" />\n    <path d=\"m20.058 20.5-8.543-8.543 8.543-8.544L18.644 2l-9.958 9.957 9.958 9.957z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol